<template>
  <div>
    <v-row justify="center">
        <v-col cols="12" sm="12" md="12" lg="12">
            <vuetify-table
                :headers="headers"
                :api-u-r-l="apiURL"
                :query-params="queryParams"
                title="Notificaciones"
                :refresh="refresh"
                :readonly="true"
            >
            <template v-slot:actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                <v-icon
                  :color="themeColor || 'primary'"
                  @click="openModal(item)"
                  v-on="on"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Mostrar</span>
              </v-tooltip>
            </template>
            </vuetify-table>
            <v-dialog
              v-model="dialog"
              max-width="620"
            >
            <v-card>
              <v-card-title class="headline">
                {{ title }}
              </v-card-title>
              <v-card-text>
                <div v-html="description"></div>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  :loading="loading"
                  @click.prevent="toggle(item)"
                >
                 Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('notification') };
    },
    components: {
        VuetifyTable,
    },
    data: () => ({
      status: 0,
      loading: false,
      check: '',
      title: '',
      description: '',
      dialog: false,
      refresh: true,
      headers: [{
          text: 'Asunto',
          value: 'title',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha creación',
          value: 'created_at_format',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha fin',
          value: 'date_end_format',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'notify_status',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      apiURL: 'api/notification/getAll',
      apiURLCheck: 'api/notification/checkNotification?type_portal=DISTRIBUIDOR',
      queryParams: '&type_portal=DISTRIBUIDOR',
    }),
    async mounted() {
      window.axios.get(`${this.apiURLCheck}`)
      .then((response) => {
        this.check = response.data;
      });
    },
    computed: {
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
      count_notify: {
        get() {
          return this.$store.state.sidebar.count_notify;
        },
        set(value) {
          this.$store.dispatch('sidebar/setSidebarCountNotify', { value });
        },
      },
    },
    methods: {
    openModal(item) {
      this.dialog = true;
      this.item = item;
      this.title = this.item.title;
      this.description = this.item.description;
    },
    toggle(item) {
      this.item = item;
      if (this.item.notify_status === 0) {
        this.loading = true;
        const url = `/api/notification/updateStatus/${this.item.id}`;
        window.axios.post(url, {
            status: 1,
          })
          .then((response) => {
            this.loading = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.$store.dispatch('sidebar/minusSidebarCountNotify');
            item.notify_status = 1;
            this.dialog = false;
          });
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>
